import { useState, useEffect } from "react";
import Target from "./components/Target/Target";
import Infinity from "./components/Infinity/Infinity";
import Ideal from "./components/Ideal/Ideal";
import Enterprise from "./components/Enterprise/Enterprise";
import Aspen from "./components/Aspen/Aspen";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import AspenDbLogs from "./components/AspenDbLogs/AspenDbLogs";
import ErrorPage from "./components/ErrorPage/ErrorPage";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Errors = () => {
  const [dmsType, setDmsType] = useState([] as any);
  const [value, setValue] = useState(0);

  // Get DMS Types for map Tabs:
  const getDmsTypes = () => {
    let url = `http://infinitylogging.csidealer.com:5111/api/DmsType?token=Y29uc3RlbGxhdGlvbjpDMG5zdGVsbEB0aW9u`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => setDmsType(data))
      .catch((error) => alert("Error: " + error));
  };

  useEffect(() => {
    getDmsTypes();
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
        >
          {dmsType &&
            dmsType.map((item: any, index: number) => (
              <Tab key={index} label={item.DmsName} {...a11yProps(index)} />
            ))}

          <Tab label="Aspen Application" {...a11yProps(dmsType.length)} />
        </Tabs>
      </Box>

      {/*----- Target -----*/}
      <TabPanel value={value} index={0}>
        <ErrorPage DMSType={101} />
      </TabPanel>

      {/*----- Ideal -----*/}
      <TabPanel value={value} index={1}>
        <ErrorPage DMSType={102} />
      </TabPanel>

      {/*----- Infinity -----*/}
      <TabPanel value={value} index={2}>
        <ErrorPage DMSType={103} />
      </TabPanel>

      {/*----- Enterprise -----*/}
      <TabPanel value={value} index={3}>
        <ErrorPage DMSType={104} />
      </TabPanel>

      {/*----- Aspen -----*/}
      <TabPanel value={value} index={4}>
        <ErrorPage DMSType={9} />
      </TabPanel>

      {/*----- Target POS -----*/}
      <TabPanel value={value} index={5}>
        <ErrorPage DMSType={105} />
      </TabPanel>

      {/*----- Target POS01 -----*/}
      <TabPanel value={value} index={6}>
        <ErrorPage DMSType={106} />
      </TabPanel>

      {/*----- Target POS02 -----*/}
      <TabPanel value={value} index={7}>
        <ErrorPage DMSType={107} />
      </TabPanel>

      {/*----- Aspen Application -----*/}
      <TabPanel value={value} index={dmsType.length}>
        <AspenDbLogs />
      </TabPanel>
    </Box>
  );
};

export default Errors;
